"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Button_1 = require("@material-ui/core/Button");
const CardContent_1 = require("@material-ui/core/CardContent");
const Typography_1 = require("@material-ui/core/Typography");
const styles_1 = require("@material-ui/core/styles");
const Card_1 = require("@material-ui/core/Card");
const Receipt_1 = require("@material-ui/icons/Receipt");
const classnames_1 = require("classnames");
const react_i18next_1 = require("react-i18next");
const ShoppingCartTable_1 = require("./ShoppingCartTable");
const SuccessPayment = ({ t, classes, items, total, transactionId, playersClubArcadeClick, playersClubStoreClick, homeClick }) => ((0, jsx_runtime_1.jsx)(Card_1.default, Object.assign({ className: classes.card }, { children: (0, jsx_runtime_1.jsx)(CardContent_1.default, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: classes.ticketIconContainer }, { children: [(0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ variant: "h5", color: 'textSecondary', className: classes.title }, { children: t('store.payment.success') })), (0, jsx_runtime_1.jsx)(Receipt_1.default, { className: classes.ticketIcon }), (0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ variant: 'body1', color: 'textSecondary' }, { children: t('store.payment.transaction', { transactionId }) })), (0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ variant: "subtitle1", color: "textSecondary", className: classes.purchasedTitle }, { children: t('store.payment.itemPurchasedLabel') })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: classes.table }, { children: (0, jsx_runtime_1.jsx)(ShoppingCartTable_1.default, { items: items, total: total }) })), (0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ variant: "subtitle1", color: "textSecondary" }, { children: t('store.payment.goto') })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: classes.buttonsContainer }, { children: [(0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ variant: 'contained', size: 'large', color: 'primary', onClick: playersClubArcadeClick, className: (0, classnames_1.default)(classes.primaryButton, classes.button) }, { children: t('store.payment.pca') })), (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ variant: 'text', size: 'large', color: 'secondary', onClick: homeClick, className: (0, classnames_1.default)(classes.secondaryButtons, classes.button) }, { children: t('store.payment.home') }))] }))] })) }) })));
const styles = (theme) => (0, styles_1.createStyles)({
    card: {
        backgroundColor: theme.palette.primary.dark.getWithAlpha(0.7)
    },
    title: {
        width: '100%',
        color: theme.palette.secondary.main,
        marginTop: theme.spacing(2.5)
    },
    ticketIcon: {
        width: '70px',
        height: '70px',
        color: theme.palette.text.secondary,
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2)
    },
    ticketIconContainer: {
        width: '100%',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column'
    },
    buttonsContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column'
    },
    secondaryButtons: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2)
    },
    button: {
        width: '250px'
    },
    primaryButton: {
        marginTop: theme.spacing(1.5),
        marginBottom: theme.spacing(2),
        paddingTop: theme.spacing(1.5),
        paddingBottom: theme.spacing(1.5)
    },
    purchasedTitle: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(2)
    },
    table: {
        marginBottom: theme.spacing(6),
        width: '60%'
    }
});
exports.default = (0, styles_1.withStyles)(styles)((0, react_i18next_1.withTranslation)()(SuccessPayment));
//# sourceMappingURL=SuccessPayment.js.map